import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { ENTREGADOR_ALTERAR_PODE_ENTRAR_ESCALA } from 'gql/entregador';

export const useToggleEntrarEscala = () => {
    const [togglePodeEntrarEscala, { loading: loadingToggleEntrarEscala }] =
        useMutation(ENTREGADOR_ALTERAR_PODE_ENTRAR_ESCALA);

    const handleToggleEntrarEscala = useCallback(
        ({ entregadorId, podeEntrarEscala }: {
            entregadorId: string;
            podeEntrarEscala: boolean;
        }) => {
            togglePodeEntrarEscala({
                variables: { entregadorId, podeEntrarEscala },
            });
        },
        [togglePodeEntrarEscala]
    );

    return {
        handleToggleEntrarEscala,
        loadingToggleEntrarEscala,
    };
};
